import { render } from "./LoginHeader.vue?vue&type=template&id=54249be5&ts=true"
import script from "./LoginHeader.vue?vue&type=script&lang=ts"
export * from "./LoginHeader.vue?vue&type=script&lang=ts"

import "./LoginHeader.vue?vue&type=style&index=0&id=54249be5&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/TEU5NrXs6/1/developers/main/tms.engine/web.js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__